module.exports = __webpack_public_path__ + "static/media/wap.2821b70a.svg";